export default "__VITE_ASSET__CopEXqgT__"